import Button from "../components/ui/Button";
import Seo from "../components/shared/Seo";

function NotFoundPage() {
  return (
    <div className="page-stack">
      <Seo
        title="404"
        description="Aradiginiz sayfa bulunamadi."
        path="/404"
        noindex
      />
      <section className="glass-panel page-hero centered-panel">
        <p className="eyebrow">404</p>
        <h1>Bu sayfa bulunamadi</h1>
        <p className="section-copy">
          Aradiginiz icerik tasinmis ya da hic olusturulmamis olabilir.
        </p>
        <Button to="/" variant="primary">
          Anasayfaya Don
        </Button>
      </section>
    </div>
  );
}

export default NotFoundPage;
